import { render, staticRenderFns } from "./MakeAClaim.vue?vue&type=template&id=4f518f5b&"
import script from "./MakeAClaim.vue?vue&type=script&lang=js&"
export * from "./MakeAClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports